import { of } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { RESPONSE_PENDING } from 'front-end-core/constants/responses'
import { $isLogged } from 'services/SessionService'

export default (loggedRequest, prepayRequest) => $isLogged.pipe(
  switchMap(isLoggedObj => {
    if (isLoggedObj === RESPONSE_PENDING) {
      return of(RESPONSE_PENDING)
    }
    const { isLogged } = isLoggedObj
    return isLogged ? loggedRequest() : prepayRequest()
  }))
